<div class="row">
  <div [class]="isMobile ? 'col-12' : 'col-2'">
    <app-profil></app-profil>
  </div>
  <div [class]="isMobile ? 'col-12' : 'col-10'">
    <div class="row">
      <app-menu-profil *ngIf="param.editDossier"></app-menu-profil>
    </div>
    <div class="row">
      <div class="col-12">
        <app-edit-infos *ngIf="param.editProfil"></app-edit-infos>
        <app-edit-password *ngIf="param.editPassword || param.editPasswordForced"></app-edit-password>
        <app-status *ngIf="param.editStatus"></app-status>
        <app-jobalert *ngIf="param.editJobalert"></app-jobalert>
        <app-piece-jointe *ngIf="param.editPj"></app-piece-jointe>
        <app-reponse-historique *ngIf="param.editReponse"></app-reponse-historique>
      </div>
    </div>
  </div>
</div>

